module.exports = __webpack_public_path__ + "img/15oz-Mug.f5605ee7.svg";